export default "__VITE_ASSET__C_qj5WKX__"